/**
 * Created by Rodrigo Quesada on 12/01/17.
 */
import {Component, Input} from '@angular/core';
import {MonthSelectorComponentModel} from './month-selector-model.class';
import {Observable, ReplaySubject} from 'rxjs';
import {combineLatest} from 'rxjs/observable/combineLatest';
import {range} from 'rxjs/observable/range';
import * as moment from 'moment';
import Moment = moment.Moment;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Component({
    selector: 'my-month-selector',
    template: require('./month-selector.component.html'),
    styles: [require('./month-selector.component.scss')]
})
export class MonthSelectorComponent {

    // region Input
    model$ = new ReplaySubject<MonthSelectorComponentModel>(1);

    @Input() set model(value: MonthSelectorComponentModel) {
        this.model$.next(value);
    }

    // endregion

    selectedDate$: Observable<Moment | undefined> = this.model$.switchMap(m => m.date$.map(it => it.value))
        .publishReplay(1).refCount();

    _selectedDateOrDefault$: Observable<Moment>;

    selectedMonth$: Observable<number | undefined> = this.selectedDate$.map(date => date ? date.month() : undefined)
        .publishReplay(1).refCount();

    set selectedMonth(value: number) { this._changeDate(date => date.month(value)); }

    selectedYear$: Observable<number | undefined> = this.selectedDate$.map(date => date ? date.year() : undefined)
        .publishReplay(1).refCount();

    set selectedYear(value: number) { this._changeDate(date => date.year(value)); }

    readonly months$: Observable<{ value: number, label: string }[]>;
    readonly years$: Observable<number[]>;

    constructor() {
        let minDate$: Observable<Moment> = this.model$.switchMap(m => m.minDate$);
        let maxDate$: Observable<Moment> = this.model$.switchMap(m => m.maxDate$).publishReplay(1).refCount();
        this._selectedDateOrDefault$ = combineLatest(this.selectedDate$, minDate$, maxDate$)
            .map(([date, minDate, maxDate]) => date ? date : moment.min(moment.max(moment(), minDate), maxDate).clone());

        let minMonth$ = combineLatest(this._selectedDateOrDefault$, minDate$)
            .map(([date, minDate]) => date.year() === minDate.year() ? minDate.month() : 0);

        let maxMonth$ = combineLatest(this._selectedDateOrDefault$, maxDate$)
            .map(([date, maxDate]) => {
                return date.year() === maxDate.year() ? maxDate.month() : 11;
            });

        this.months$ = combineLatest(minMonth$, maxMonth$)
            .flatMap(([minMonth, maxMonth]) => {
                return range(minMonth, maxMonth - minMonth + 1)
                    .map(m => ({value: m, label: MONTHS[m]}))
                    .toArray();
            });

        this.years$ = combineLatest(minDate$, maxDate$)
            .flatMap(([minDate, maxDate]) => range(minDate.year(), maxDate.year() - minDate.year() + 1).toArray())
            .map(values => values.reverse());
    }

    previousYear() {
        this._changeDate(date => date.subtract(1, 'year'));
    }

    nextYear() {
        this._changeDate(date => date.add(1, 'year'));
    }

    //region Utils
    private _changeDate(body: (Moment) => Moment) {
        combineLatest(this.model$, this._selectedDateOrDefault$)
            .first()
            .do(([model, selectedDate]) => model.dateSelection = body(selectedDate))
            .subscribe();
    }

    //endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/monthpicker/selector/month-selector.component.ts